<script setup lang="ts">
import {WidgetProps} from "@/utils/presenters/interfaces.ts";
import EditScreenFieldUtils from "@/utils/editView/editScreens/EditScreenFieldUtils.ts";
import {ref} from "vue";
import {NamaNavigationArgs, NamaVueWidget} from "@/utils/common/NamaVueWidget.ts";

let props = defineProps<WidgetProps>();
const c = ref<NamaVueWidget>();

function focus(args:NamaNavigationArgs): void {
  if (c.value?.focus)
    c.value.focus(args);
}

function canReceiveFocus(): boolean {
  if (c.value?.canReceiveFocus)
    return c.value.canReceiveFocus();
  else
    return false;
}

defineExpose({canReceiveFocus, focus})
</script>

<template>
  <component v-if="fieldMetaData" :is="EditScreenFieldUtils.createField(presenter, fieldMetaData)" :field="field"
             :isInsideComposite="isInsideComposite" :isSpanned="isSpanned"
             :fieldMetaData="fieldMetaData" :presenter="presenter" :doNotApplyThemeLayouts="doNotApplyThemeLayouts" :forceEnableField="forceEnableField"
             @navigateToNext="(args)=>$emit('navigateToNext',args)" ref="c"/>
</template>

<style scoped>

</style>
